import React from 'react';

export default function PurchaseReceiveGeneral({ setError, error, setForm, form }) {
	return <div>Development In Progress</div>;
}
